import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import BecomeUtilityMember from "./BecomeUtilityMember.jsx";
import BecomeCorporateMember from "./BecomeCorporateMember.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class NewMembership extends Component {
    constructor(props) {
        super(props);
        this.state = {
            membershipType: window.location.search.match(/corporate/) ? 2 : 1
        };
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick(e) {
        this.setState({ membershipType: Number(e.target.dataset.membershipType) });
    }

    render() {
        let aboutMembership;
        if (this.state.membershipType == 1) {
            aboutMembership = <BecomeUtilityMember />;
        } else if (this.state.membershipType == 2) {
            aboutMembership = <BecomeCorporateMember />;
        }
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background new-membership-page">
                    <Banner heading="New Membership" />
                    <BackButton href={hyperlinks["membership"]} text="❮ Membership" />
                    <Row className="new-membership-content">
                        <Col md={8} mdOffset={2}>
                            <Row>
                                <Col md={4} mdOffset={2}>
                                    <Button className={`membership-type${this.state.membershipType == 1 ? " active" : ""}`} onClick={this.handleButtonClick} data-membership-type={1}>Utility membership</Button>
                                </Col>
                                <Col md={4}>
                                    <Button className={`membership-type${this.state.membershipType == 2 ? " active" : ""}`} onClick={this.handleButtonClick} data-membership-type={2}>Corporate membership</Button>
                                </Col>
                            </Row>
                            {aboutMembership}
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/NewMembership.jsx.erb